import { siteNames } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Helmet } from 'react-helmet';

import type { EmployerSiteNames } from '../../../siteConfig';

import translations from './.vocab';

interface props {
  site: EmployerSiteNames;
}
export const AppTitle = ({ site }: props) => {
  const { t } = useTranslations(translations);

  const getTitleText = (): string => {
    switch (site) {
      case siteNames.employer.seek.au:
        return t(
          "SEEK - Australia's no. 1 jobs, employment, career and recruitment site",
        );
      case siteNames.employer.seek.nz:
        return t(
          "Jobs on SEEK - New Zealand's no. 1 Employment, Career and Recruitment site",
        );
      case siteNames.employer.seek.th:
      case siteNames.employer.seek.hk:
      case siteNames.employer.seek.id:
      case siteNames.employer.seek.my:
      case siteNames.employer.seek.ph:
      case siteNames.employer.seek.sg:
      default:
        // FIXME: Not available for unified site
        return t('SEEK - jobs, employment, career and recruitment site');
    }
  };

  return <Helmet title={getTitleText()} />;
};
